import update from 'immutability-helper';
import { createReducer } from '@api/createRequestStore';
import * as types from './types';

const initialState = {};
const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SETUP_METRIC] = (state, action) => {
  const { metric, metricStore } = action;
  return update(state, {
    [metric]: { $set: metricStore },
  });
}

switchMap[types.SET_FETCHING] = (state, action) => {
  const { metric, isFetching } = action;
  return update(state, {
    [metric]: {
      $merge: {
        isFetching
      },
    },
  });
}

switchMap[types.SET_RESPONSE] = (state, action) => {
  const { metric, response } = action;
  return update(state, {
    [metric]: {
      $merge: {
        response
      },
    },
  });
}

switchMap[types.SET_CHART_DATA] = (state, action) => {
  const { metric, chartData } = action;
  return update(state, {
    [metric]: {
      $merge: {
        chartData
      },
    },
  });
}

switchMap[types.SET_TOTAL_VALUE] = (state, action) => {
  const { metric, metricValue } = action;
  return update(state, {
    [metric]: {
      $merge: {
        metricValue
      },
    },
  });
}

switchMap[types.SET_ERROR] = (state, action) => {
  const { errorCode, errorMsg, metric } = action;
  return update(state, {
    [metric]: {
      $merge: {
        errorCode,
        errorMsg,
        invalid: false,
      },
    },
  });
}

export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);
